if (!customElements.get("c-product-card")) {
  customElements.define(
    "c-product-card",
    class ProductCard extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.inWishlist = false

        this.wishlistButton = this.querySelector('.js-product-card__wish-button')

        this.wishlistButton.addEventListener('click', this.wishlistButtonClickHandler)

        this.wishlistLoadedUnsubscriber = subscribe('wishlist-loaded', (list) => {
          for (const item of list.listcontents) {
            if (item.epi == this.dataset.variantId && item.empi == this.dataset.productId) {
              this.inWishlist = true
              break
            }
          }

          this.updateWishlistButton()
        })

        this.wishlistAddUnsubscriber = subscribe('wishlist-add-product', (product) => {
          if (product.epi === this.dataset.variantId && product.empi === this.dataset.productId) {
            this.inWishlist = true
            this.updateWishlistButton()
          }
        })

        this.wishlistRemoveUnsubscriber = subscribe('wishlist-remove-product', (product) => {
          if (product.epi === this.dataset.variantId && product.empi === this.dataset.productId) {
            this.inWishlist = false
            this.updateWishlistButton()
          }
        })

        this.updateWishlistButton()
      }

      disconnectedCallback() {
        this.wishlistButton.removeEventListener('click', this.wishlistButtonClickHandler)

        this.wishlistLoadedUnsubscriber();
        this.wishlistAddUnsubscriber();
        this.wishlistRemoveUnsubscriber();
      }

      updateWishlistButton = () => {
        if (this.inWishlist) {
          this.wishlistButton.classList.add('is-active')
        } else {
          this.wishlistButton.classList.remove('is-active')
        }
      }

      wishlistButtonClickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }

        if (!this.inWishlist) {
          window.SwymCallbacks.push(this.addToWishlist)
        } else {
          window.SwymCallbacks.push(this.removeFromWishlist)
        }
      }

      addToWishlist = (swat) => {
        // Define the product object
        const product = {
          epi: this.dataset.variantId, // Unique variant ID of the product
          empi: this.dataset.productId, // Master Product Id of the product
          du: this.dataset.productUrl, // Product URL
        };

        // Define success callback
        let onSuccessAdd = (addedListItem) => {
          // Success response is the added product.
          this.inWishlist = true
          this.updateWishlistButton()

          publish('wishlist-add-product', product)

          if (this.dataset.openWishlist === 'true') {
            publish('open-wishlist-drawer');
          }
        }

        // Define error callback
        let onErrorAdd = (error) => {
          // Error is an xhrObj
          console.error("Error while adding the Product to the List", error);
          this.wishlistButton.classList.remove('is-active')
        }

        // Call `addToList` with the above callbacks, lid and product object
        swat.addToList(window.apps.wishlist.listId, product, onSuccessAdd, onErrorAdd);
      }

      removeFromWishlist = (swat) => {
        // Define the product object
        const product = {
          epi: this.dataset.variantId, // Unique variant ID of the product
          empi: this.dataset.productId, // Master Product Id of the product
          du: this.dataset.productUrl, // Product URL
        };

        // Define success callback
        let onSuccessRemove = (deletedProduct) => {
          // Success response is the removed product.
          this.inWishlist = false
          this.updateWishlistButton()

          publish('wishlist-remove-product', product)
        }

        // Define error callback
        let onErrorRemove = (error) => {
          // Error is an xhrObj
          console.error("Error while deleting the Product", error);
        }

        // Call `deleteFromList` with the above callbacks, lid and product object
        swat.deleteFromList(window.apps.wishlist.listId, product, onSuccessRemove, onErrorRemove);
      }
    }
  );
}
